export const SCREENS_HEADINGS = [
  ["name", "Test Name"],
  ["code", "Test Code"],
];

export const COMMODITIES_HEADINGS = [["name", "Commodity Name"]];

export const headerStyle = {
  background: "#E8F5E1",
  color: "#71BF44",
};

/**
 * Default error messages
 */
export const ERROR_MESSAGES = {
  FETCH_ERROR: "Failed to fetch data. Please try again.",
  REPORT_ERROR: "Failed to generate report. Please try again.",
  NO_COMMODITY: "Select at least one commodity.",
  NO_SCREEN: "Select at least one test screen.",
  INVALID_DATE: "Invalid date range.",
  PERCENTAGE_REQUIRED: "Percentage criteria is required.",
  PERMISSION_ERROR: "You don't have permission to generate this report.",
};

/**
 * Success messages
 */
export const SUCCESS_MESSAGES = {
  REPORT_GENERATED:
    "Report generation started. You will receive the report via email shortly.",
};

/**
 * Sample screens data for testing
 */
export const SAMPLE_SCREENS = [
  { id: "1", name: "M3 Micro Test", code: "M3" },
  { id: "2", name: "C6 Chemical Test", code: "C6" },
  { id: "3", name: "M5 Micro Test", code: "M5" },
  { id: "4", name: "HM2 Heavy Metals", code: "HM2" },
  { id: "5", name: "Dry Matter", code: "DM" },
];

/**
 * Sample commodities data for testing
 */
export const SAMPLE_COMMODITIES = [
  { id: "1", name: "Apple" },
  { id: "2", name: "Artichoke" },
  { id: "3", name: "Apricot" },
  { id: "4", name: "Aspargus" },
  { id: "5", name: "Avocado" },
];
